import React, { use, useState } from 'react'
import "./Topbar.scss";
import { BsSearch } from "react-icons/bs";
import { IoNotificationsOutline } from "react-icons/io5";
import { MdFormatListBulleted } from "react-icons/md";
import { useLocation } from 'react-router-dom';
import { NavLink } from 'react-router-dom';


const Topbar: React.FC = () => {

  const [CurrToken, setCurrToken] = useState(900);

  const location = useLocation();
  const state = location.state as { courseTitle?: string };


  const pageTitles: Record<string, string> = {
    "/": "Home",
    "/journal": "Journals",
    "/learning": "Learning",
    "/courses": "Courses",
    "/upgrades": "Upgrades",
  };

  const baseTitle = pageTitles[location.pathname] || "Page";


  const [filter, setFilter] = useState(false)
  return (
    <div className="topbar">
      <div className="topbar_left">
        <p className="topbar_title">{baseTitle}</p>
        {state?.courseTitle && (
          <>
            <span className="separator"> / </span>
            <p className="topbar_course">{state.courseTitle}</p>
          </>
        )}
      </div>

      <button className="mobile_filter_btn" onClick={() => setFilter(!filter)}>
        <MdFormatListBulleted />
      </button>

      <div className={`topbar_right ${filter ? "show" : ""}`}>


        {CurrToken < 1000 && ( 
          <div className="tokenWarning">
            <p>LOW TOKENS</p>
          </div>
        )}



        <div className="topbar_search">
          <BsSearch />
          <input type="text" placeholder="Search" />
        </div>
     
          <NavLink to="/upgrades">
        <button className="upgrade">
          Upgrade
        </button>
          </NavLink>
        
 
        <div className='notification'>
          <IoNotificationsOutline />
        </div>
        <img src="/images/Profile.jpg" alt="Profile" className="topbar_profile" />
      </div>
    </div>
  )
}

export default Topbar
